import { v4 as uuidv4 } from 'uuid'

export const DEFAULT_NOTIFICATION_TIMEOUT_MS = 120000 // 2 minutes

export const NotifyMessageType = Object.freeze({
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error'
})

export class NotifyMessage {
  #uuid
  #type
  #title
  #message
  #details
  #timeout

  constructor (type, title, message, details, timeout) {
    this.#uuid = uuidv4()
    if (Object.values(NotifyMessageType).includes(type)) {
      this.#type = type
    } else {
      throw new Error(`Type ${type} does not exist in NotifyMessageType`)
    }
    this.#title = title
    this.#message = message
    this.#details = details
    this.#timeout = Number(timeout) || DEFAULT_NOTIFICATION_TIMEOUT_MS
    Object.freeze(this.#uuid)
    Object.freeze(this.#type)
    Object.seal(this)
    Object.preventExtensions(this)
  }

  static typed (type, title, message, details, timeout) {
    return new NotifyMessage(type, title, message, details, timeout)
  }

  static info (args) {
    const { title, message, details, timeout } = args || {}
    return this.typed(NotifyMessageType.INFO, title, message, details, timeout)
  }

  static success (args) {
    const { title, message, details, timeout } = args || {}
    return this.typed(NotifyMessageType.SUCCESS, title, message, details, timeout)
  }

  static error (args) {
    const { title, message, details, timeout } = args || {}
    return this.typed(NotifyMessageType.ERROR, title, message, details, timeout)
  }

  withTitle (title) {
    this.#title = title
    return this
  }

  withMessage (message) {
    this.#message = message
    return this
  }

  withDetails (details) {
    this.#details = details
    return this
  }

  get uuid () {
    return this.#uuid
  }

  get type () {
    return this.#type
  }

  get title () {
    return this.#title
  }

  get message () {
    return this.#message
  }

  get details () {
    return this.#details
  }

  get timeout () {
    return this.#timeout
  }

  valid () {
    return (
      Object.values(NotifyMessageType).includes(this.#type) &&
      this.#message &&
      typeof this.#message === 'string'
    )
  }
}
